
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0a294a","d":"M11.042 7.074a1.27 1.27 0 00-.386.932c0 .364.134.675.402.932s.584.385.948.385.68-.128.948-.385c.268-.257.401-.568.401-.932 0-.364-.133-.68-.401-.948a1.297 1.297 0 00-.948-.402c-.364 0-.686.14-.964.418zm2.804-.964a2.51 2.51 0 01.799 1.884c0 .724-.256 1.347-.767 1.868-.51.522-1.139.783-1.884.783-.745 0-1.373-.261-1.884-.783a2.576 2.576 0 01-.766-1.868c0-.745.26-1.378.782-1.9a2.55 2.55 0 011.868-.782c.724 0 1.341.266 1.852.798zm-4.678-.942C8.389 5.947 8 6.891 8 8c0 1.11.39 2.053 1.168 2.832C9.947 11.611 10.891 12 12 12c1.11 0 2.048-.384 2.816-1.152C15.606 10.058 16 9.109 16 8c0-1.11-.39-2.053-1.168-2.832C14.053 4.389 13.109 4 12 4c-1.11 0-2.053.39-2.832 1.168zm7.216-1.167c1.323.94 2.73 2.275 4.224 4.005-1.45 1.687-2.859 3.011-4.224 3.972-1.259.897-2.72 1.345-4.384 1.345-1.664 0-3.125-.448-4.384-1.345-1.365-.961-2.773-2.285-4.224-3.972C4.885 6.276 6.293 4.94 7.616 4c1.259-.897 2.72-1.345 4.384-1.345 1.664 0 3.125.448 4.384 1.345zM6.048 1.824c-1.024.725-2.064 1.637-3.12 2.736-.894.93-1.535 1.63-1.925 2.102l-.187.234a33.85 33.85 0 00-.713.958L0 8l.736.992.155.204c.489.629 1.189 1.409 2.101 2.34a22.57 22.57 0 003.056 2.64C7.733 15.392 9.718 16 12 16c2.261 0 4.235-.608 5.92-1.824 1.024-.725 2.07-1.637 3.136-2.736 1.067-1.099 1.776-1.877 2.128-2.336l.325-.428c.15-.2.279-.376.388-.53L24 8l-.923-1.196c-.489-.629-1.189-1.409-2.101-2.34a22.57 22.57 0 00-3.056-2.64C16.235.608 14.261 0 12 0 9.717 0 7.733.608 6.048 1.824z","opacity":".75"}})])
          )
        }
      }
    